"use client";

import React from "react";

export type ProfileFilterChipProps = Readonly<{
  isActive: boolean;
  label: React.ReactNode;
  onClick: () => void;
  /**
   * `toolbar` (default) renders a pressable button (`aria-pressed`).
   * `tab` renders a tab within a `role="tablist"` container (`aria-selected`).
   */
  variant?: "toolbar" | "tab";
  ariaLabel?: string;
  componentInstance?: string;
  disabled?: boolean;
}>;

/**
 * Shared pill/chip used for every section filter (expertise, offerings,
 * credentials, etc.). Single source of truth for the size, shape, and
 * black-active state so no view drifts from the standard appearance.
 */
export function ProfileFilterChip({
  isActive,
  label,
  onClick,
  variant = "toolbar",
  ariaLabel,
  componentInstance,
  disabled,
}: ProfileFilterChipProps) {
  const stateProps = variant === "tab"
    ? { role: "tab" as const, "aria-selected": isActive }
    : { "aria-pressed": isActive };

  return (
    <button
      type="button"
      className={isActive ? "profile-filter-chip profile-filter-chip--active" : "profile-filter-chip"}
      onClick={onClick}
      disabled={disabled}
      {...(ariaLabel ? { "aria-label": ariaLabel } : {})}
      {...(componentInstance ? { "data-component-instance": componentInstance } : {})}
      {...stateProps}
    >
      {label}
    </button>
  );
}
